import { cn } from '@/lib/utils';
import { Pacifico } from 'next/font/google';

const pacifico = Pacifico({
    weight: '400',
    subsets: ['latin'],
});

/* Monochrome only — the wordmark renders the way an e-ink panel would show it.
   `ink` follows the theme (night mode inverts it); `paper` is for surfaces that
   stay dark in both modes (footer, CTA bands). */
const gradients = {
    ink: 'bg-linear-to-r from-neutral-900 to-neutral-600 dark:from-neutral-100 dark:to-neutral-400',
    paper: 'bg-linear-to-r from-neutral-100 to-neutral-400',
};

interface LogoProps {
    gradient?: keyof typeof gradients;
    className?: string;
}

export default function Logo({ gradient = 'ink', className }: LogoProps) {
    // Pacifico's swashes overshoot the line box; the padding (offset by negative
    // margins) grows the background-clip area so the gradient covers them.
    return (
        <span
            className={cn(
                'text-3xl font-bold',
                pacifico.className,
                gradients[gradient],
                'bg-clip-text text-transparent',
                'px-[0.15em] py-[0.4em] -mx-[0.15em]',
                className,
            )}
        >
            Readry
        </span>
    );
}
